import { render, staticRenderFns } from "./CellList.vue?vue&type=template&id=665048ca&scoped=true"
import script from "./CellList.vue?vue&type=script&lang=js"
export * from "./CellList.vue?vue&type=script&lang=js"
import style0 from "./CellList.vue?vue&type=style&index=0&id=665048ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665048ca",
  null
  
)

export default component.exports